var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 21.5,
    stroke: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_84_24002)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.3327 15.3417C29.4993 15.75 28.6827 15.9158 27.8327 16.1667C26.8985 15.1125 25.5135 15.0542 24.1827 15.5525C22.8518 16.0508 21.9802 17.2692 21.9993 18.6667V19.5C19.2952 19.5692 16.8868 18.3375 15.3327 16.1667C15.3327 16.1667 11.8477 22.3608 18.666 25.3333C17.106 26.3725 15.5502 27.0733 13.666 27C16.4227 28.5025 19.4268 29.0192 22.0277 28.2642C25.011 27.3975 27.4627 25.1617 28.4035 21.8125C28.6842 20.7939 28.8235 19.7416 28.8177 18.685C28.816 18.4775 30.076 16.375 30.3327 15.3408V15.3417Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_84_24002"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.7b6b2cadf572b013c626b81afd617723.svg";
export { ForwardRef as ReactComponent };